import { IdentityService } from '../services/IdentityService';
import { Store, AnyAction } from 'redux';
import * as Actions from '../actions/ActionsIndex';
import { ClientStateService } from '../services/ClientStateService';

export class StoreInitializer {
    constructor(private store: Store<{}, AnyAction>) {
        this.OnGetProfileInfoSuccess = this.OnGetProfileInfoSuccess.bind(this);
        this.OnGetProfileInfoError = this.OnGetProfileInfoError.bind(this);
        this.OnGetClientStateSuccess = this.OnGetClientStateSuccess.bind(this);
        this.OnGetClientStateError = this.OnGetClientStateError.bind(this);
    }

    public InitializeStore(): void {
        this.InitializeIdentityStore();
    }

    private InitializeIdentityStore(): void {
        let clientStateService = new ClientStateService();
        clientStateService.GetState(this.OnGetClientStateSuccess, this.OnGetClientStateError);
        let service = new IdentityService();
        service.GetProfileInfo(this.OnGetProfileInfoSuccess, this.OnGetProfileInfoError);
    }

    private OnGetProfileInfoSuccess(result: any): void {
        this.store.dispatch(Actions.SetProfileInfo(result.data.Value));
    }

    private OnGetProfileInfoError(error: any): void {
        console.error(error);
    }

    private OnGetClientStateSuccess(result) {
        if (result.data.SearchData) {
            if (typeof (result.data.SearchData.SelectedDateFrom) === "string") {
                result.data.SearchData.SelectedDateFrom = new Date(result.data.SearchData.SelectedDateFrom);
            }
            if (typeof (result.data.SearchData.SelectedDateTo) === "string") {
                result.data.SearchData.SelectedDateTo = new Date(result.data.SearchData.SelectedDateTo);
            }
        }
        this.store.dispatch(Actions.SetFullClientState(result.data));
        //if (result.data.Visit) {
        //    result.data.Visit.StartTime = new Date(result.data.Visit.StartTime);
        //    this.store.dispatch(Actions.SetVisitInfo(result.data.Visit));
        //}
    }

    private OnGetClientStateError(error) {
        console.error(error);
    }
}



// WEBPACK FOOTER //
// ./src/stores/StoreInitializer.tsx